import { render, staticRenderFns } from "./fileViewer.component.vue?vue&type=template&id=7a2d7413&scoped=true&"
import script from "./fileViewer.component.vue?vue&type=script&lang=js&"
export * from "./fileViewer.component.vue?vue&type=script&lang=js&"
import style0 from "./fileViewer.component.vue?vue&type=style&index=0&id=7a2d7413&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2d7413",
  null
  
)

export default component.exports